import * as yup from 'yup'
import { messages } from 'helpers/validationMessages'
import dayjs from 'dayjs'

const ONE_YEAR_FROM_NOW = new Date()
ONE_YEAR_FROM_NOW.setFullYear(ONE_YEAR_FROM_NOW.getFullYear() + 1)

export const orderFormSchema = yup.object().shape({
  price: yup
    .string()
    .required(messages.required)
    .max(250, messages.maxLength(250))
    .test('notOnlySpaces', messages.required, value => value.trim() !== ''),
  comment: yup.string(),
  date: yup
    .string()
    .nullable()
    .test('valid-and-in-range', 'Недопустимая дата', value => {
      if (!value) return true

      const date = dayjs(value, 'YYYY-MM-DD', true)
      if (!date.isValid()) return false

      const now = dayjs().startOf('day')
      const max = dayjs().add(1, 'year').endOf('day')

      return date >= now && date <= max
    }),
})
